import { render, staticRenderFns } from "./textlist_2.vue?vue&type=template&id=ce2f42dc&scoped=true"
import script from "./textlist_2.vue?vue&type=script&lang=js"
export * from "./textlist_2.vue?vue&type=script&lang=js"
import style0 from "./textlist_2.vue?vue&type=style&index=0&id=ce2f42dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2f42dc",
  null
  
)

export default component.exports